import React from 'react';
import { UniversalDashboardRenderer } from '../../../../../dashboard/components/common/UniversalDashboardRenderer';

import { useTranslation } from 'react-i18next';

interface MarkdownDashboardProps {
  code: string;
}

export const MarkdownDashboard: React.FC<MarkdownDashboardProps> = ({
  code,
}) => {
  const { t } = useTranslation('pleri/chat');
  return (
    <UniversalDashboardRenderer
      code={code}
      variant="expandable"
      enableExpand
      enablePDF
      enableScreenshot
      enableScaling
      title={t('dashboard')}
      height="350px"
      className="my-4"
      designWidth={1400}
      maxScale={0.5}
      minScale={0.25}
    />
  );
};
